export default {
  "hero.badge": "Recurso independiente • Actualizado con regularidad • Centrado en la seguridad",
  "hero.title": "USFans Spreadsheet — descubre creadores, guías y recursos de USFans",
  "hero.subtitle": "Explora un spreadsheet estructurado de USFans y un centro de recursos diseñado para ayudarte a descubrir información de creadores, comparar recursos, entender costes de envío y encontrar guías útiles en un solo lugar.",
  "hero.ctaPrimary": "Explorar USFans Spreadsheet",
  "hero.ctaSecondary": "Ver guías de USFans",
  "hero.trust": "Recurso independiente • Actualizado con regularidad • Centrado en la seguridad",

  "heroSupport.title": "¿Buscas una forma más sencilla de explorar información de USFans?",
  "heroSupport.body": "Nuestro USFans Spreadsheet organiza información útil en una estructura fácil de recorrer. Explora categorías, guías, comparaciones, preguntas frecuentes y recursos prácticos desde un único centro.",
  "heroSupport.cta": "Abrir el USFans Spreadsheet",

  "value.title": "Todo lo que necesitas saber sobre USFans en un solo lugar",
  "value.subtitle": "Seis recursos clave, organizados para una investigación más rápida y segura.",
  "value.spreadsheet.title": "USFans Spreadsheet",
  "value.spreadsheet.body": "Explora información estructurada a través de un recurso tipo hoja de cálculo fácil de navegar.",
  "value.directory.title": "Directorio de creadores",
  "value.directory.body": "Explora recursos y categorías relacionadas con creadores en una vista limpia y organizada.",
  "value.reviews.title": "Reseñas de USFans",
  "value.reviews.body": "Comprende qué debes considerar al evaluar USFans y servicios relacionados.",
  "value.shipping.title": "Envío y costes",
  "value.shipping.body": "Explora guías de envío, almacén y costes para planificar con antelación.",
  "value.coupons.title": "Cupones y descuentos",
  "value.coupons.body": "Encuentra información sobre cupones, códigos de descuento y promociones.",
  "value.safety.title": "Centro de seguridad",
  "value.safety.body": "Aprende a identificar enlaces sospechosos y a proteger tu información.",

  "spreadsheet.title": "El USFans Spreadsheet",
  "spreadsheet.body": "El USFans Spreadsheet es el recurso central de USFansLink.wiki. Organiza información útil sobre creadores y recursos en un formato estructurado para que los visitantes puedan navegar, comparar y descubrir información de forma más eficiente.",
  "spreadsheet.colCreator": "Creador / Recurso",
  "spreadsheet.colCategory": "Categoría",
  "spreadsheet.colType": "Tipo",
  "spreadsheet.colInfo": "Información",
  "spreadsheet.colUpdated": "Actualizado",
  "spreadsheet.rowTypeProfile": "Perfil",
  "spreadsheet.rowTypeGuide": "Guía",
  "spreadsheet.rowTypeResource": "Recurso",
  "spreadsheet.view": "Ver recurso",
  "spreadsheet.cta": "Explorar el USFans Spreadsheet completo →",
  "spreadsheet.group.footwear": "Calzado",
  "spreadsheet.group.apparel": "Ropa",
  "spreadsheet.group.accessories": "Accesorios",
  "spreadsheet.group.other": "Otros",

  "search.title": "Búsquedas populares de USFans",
  "search.subtitle": "Salta a los temas que la gente busca con más frecuencia.",
  "search.review.title": "Reseña de USFans",
  "search.review.body": "Qué considerar antes de confiar en un recurso de USFans.",
  "search.shipping.title": "Coste de envío de USFans",
  "search.shipping.body": "Una mirada práctica a envíos, métodos y plazos.",
  "search.coupon.title": "Cupón de USFans",
  "search.coupon.body": "Dónde buscar cupones y qué esperar.",
  "search.discount.title": "Código de descuento de USFans",
  "search.discount.body": "Cómo funcionan los códigos de descuento y cómo verificarlos.",
  "search.warehouse.title": "Almacén de USFans",
  "search.warehouse.body": "Comprende el proceso del almacén y su función.",
  "search.legit.title": "¿Es legítimo USFans?",
  "search.legit.body": "Una guía equilibrada para evaluar la legitimidad con seguridad.",

  "compare.title": "Recursos de USFans comparados",
  "compare.colResource": "Recurso",
  "compare.colBestFor": "Ideal para",
  "compare.colGuides": "Guías",
  "compare.colComparison": "Comparación",
  "compare.colSafety": "Seguridad",
  "compare.rowSpreadsheet": "USFans Spreadsheet",
  "compare.rowSpreadsheetBest": "Navegación organizada",
  "compare.rowDirectory": "Directorio de creadores",
  "compare.rowDirectoryBest": "Descubrimiento",
  "compare.rowShipping": "Guía de envío",
  "compare.rowShippingBest": "Investigación de envíos",
  "compare.rowReview": "Guía de reseñas",
  "compare.rowReviewBest": "Evaluación",

  "how.title": "Cómo funciona el centro de recursos de USFans",
  "how.subtitle": "Un sencillo proceso de cuatro pasos para investigar con confianza.",
  "how.step1.title": "Explora",
  "how.step1.body": "Encuentra el USFans Spreadsheet o un tema específico.",
  "how.step2.title": "Compara",
  "how.step2.body": "Usa guías y tablas para entender las diferencias.",
  "how.step3.title": "Verifica",
  "how.step3.body": "Revisa la información de seguridad antes de visitar sitios externos.",
  "how.step4.title": "Continúa",
  "how.step4.body": "Visita el sitio principal cuando los recursos adicionales sean relevantes.",
  "how.cta": "Explorar USFans Spreadsheet",

  "trust.title": "Creado para una mejor investigación de USFans",
  "trust.subtitle": "Estándares claros, información transparente y orientación honesta.",
  "trust.item1": "Plataforma de recursos independiente",
  "trust.item2": "Contenido editorial",
  "trust.item3": "Fechas de actualización claras",
  "trust.item4": "Orientación de seguridad",
  "trust.item5": "Aviso legal transparente",
  "trust.item6": "Sin reseñas falsas",
  "trust.item7": "Sin estadísticas inventadas",
  "trust.about": "Acerca de",
  "trust.editorial": "Política editorial",
  "trust.update": "Política de actualización",
  "trust.safetyLink": "Centro de seguridad",

  "faq.title": "Preguntas frecuentes",
  "faq.subtitle": "Respuestas rápidas a las preguntas más comunes sobre el USFans Spreadsheet.",
  "faq.q1": "¿Qué es un spreadsheet de USFans?",
  "faq.a1": "Un spreadsheet de USFans es un recurso estructurado que organiza información de creadores, categorías y referencias en un único formato fácil de recorrer.",
  "faq.q2": "¿Cómo funciona el spreadsheet de USFans?",
  "faq.a2": "Agrupa información relacionada en filas y categorías para que puedas escanear, comparar y saltar a recursos relevantes sin abrir muchas páginas separadas.",
  "faq.q3": "¿Qué información puedo encontrar?",
  "faq.a3": "Puedes encontrar referencias de creadores, enlaces de categorías, guías y recursos prácticos relacionados con la exploración del contenido de USFans.",
  "faq.q4": "¿Es legítimo USFans?",
  "faq.a4": "Ofrecemos orientación sobre cómo evaluar la legitimidad en lugar de un único veredicto. Verifica siempre las fuentes y evita enlaces sospechosos.",
  "faq.q5": "¿Cuánto cuesta el envío de USFans?",
  "faq.a5": "Los costes de envío pueden variar según la región, el método y el pedido. Consulta los detalles más recientes en el sitio principal antes de comprar.",
  "faq.q6": "¿USFans ofrece cupones?",
  "faq.a6": "Los cupones y promociones pueden aparecer de vez en cuando. Recomendamos verificar cualquier oferta activa directamente en el sitio principal.",
  "faq.q7": "¿Qué es un código de descuento de USFans?",
  "faq.a7": "Un código de descuento es un texto corto que introduces al pagar para aplicar una promoción. Confirma siempre que el código esté vigente antes de usarlo.",
  "faq.q8": "¿Cómo funciona el almacén de USFans?",
  "faq.a8": "El almacén se encarga del almacenamiento y envío de los pedidos. Los plazos pueden depender de la ubicación y la disponibilidad de stock.",
  "faq.q9": "¿Cómo debo evaluar las reseñas de USFans?",
  "faq.a9": "Busca comentarios coherentes y detallados en varias fuentes en lugar de depender de una sola opinión o valoración.",
  "faq.q10": "¿Está USFansLink.wiki afiliado oficialmente con USFans?",
  "faq.a10": "No. USFansLink.wiki es un recurso informativo independiente y no está afiliado ni respaldado por USFans.",

  "finalCta.title": "Empieza a explorar el USFans Spreadsheet",
  "finalCta.body": "Explora recursos, guías, comparaciones e información de seguridad de USFans desde un único centro.",
  "finalCta.primary": "Explorar USFans Spreadsheet",
  "finalCta.secondary": "Visitar el sitio principal",

  "pillar.title": "Guías y recursos de USFans",
  "pillar.subtitle": "Guías originales y detalladas sobre reseñas, envíos, cupones, seguridad y más.",
  "pillar.readMore": "Leer guía",
};